import { InputAdornment } from "@mui/material";

const timeEndAdornment = {
  InputProps: {
    endAdornment: (
      <InputAdornment position="end" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
        hr
      </InputAdornment>
    ),
  },
};

export default timeEndAdornment;
